import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=11a18753&scoped=true"
import script from "./LocaleSelector.vue?vue&type=script&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./LocaleSelector.vue?vue&type=style&index=0&id=11a18753&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./LocaleSelector.vue?vue&type=style&index=1&id=11a18753&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "11a18753",
  "618668ca"
  
)

export default component.exports